import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-wrh-blue-dark t-18m pb-2 mt-6 mdlg:mt-0 mdlg:col-start-1 mdlg:col-end-2"
}
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = { class: "relative" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  for: "Name",
  class: "wrh-input-label mb-2"
}, "First Name", -1)
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "wrh-error firstname-error"
}
const _hoisted_7 = { class: "relative" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "Name",
  class: "wrh-input-label mb-2"
}, "Last Name", -1)
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 0,
  class: "wrh-error"
}
const _hoisted_11 = { class: "relative" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  class: "wrh-input-label mb-2",
  for: "Phone"
}, "Phone Number", -1)
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 0,
  class: "wrh-error phone-error"
}
const _hoisted_15 = { class: "relative" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  class: "wrh-input-label mb-2",
  for: "email"
}, "Email Address", -1)
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 0,
  class: "wrh-error email-error"
}
const _hoisted_19 = {
  key: 0,
  class: "wrh-error relative"
}
const _hoisted_20 = { class: "flex justify-end pt-3" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  key: 1,
  class: "btn w-full bg-wrh-blue-light text-white rounded uppercase py-2 hover:bg-wrh-blue-600 focus:outline-none transition-colors duration-300 ease-in-out"
}
const _hoisted_23 = { class: "row-start-1 row-end-2 mt-6 mdlg:mt-0 md:row-start-auto md:row-end-auto mdlg:row-start-1 mdlg:row-end-3 mdlg:col-start-2 mdlg:col-end-3" }
const _hoisted_24 = {
  key: 0,
  class: "text-wrh-blue-dark t-18m pb-2 mb-6 mdlg:mb-4 mdlg:pl-3"
}
const _hoisted_25 = { class: "space-y-6 wrh-scroll mdlg:h-[428px] lg:h-[340px] lgDeskop:h-[428px] p-3" }
const _hoisted_26 = { class: "grid grid-cols-[40px,1fr] gap-x-3 mb-2" }
const _hoisted_27 = { class: "t-14b mdlg:t-16m text-wrh-blue-dark flex items-center" }
const _hoisted_28 = { class: "text-white bg-wrh-blue-light t-14r mdlg:t-16r rounded-md px-2 py-1 inline ml-1 absolute -top-2 right-0" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { class: "text-wrh-gray-dark t-14r mdlg:t-16r pl-13" }
const _hoisted_31 = { class: "break-all" }
const _hoisted_32 = ["disabled", "onClick"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("button", { class: "btn w-full bg-wrh-blue-light text-white rounded uppercase py-2 hover:bg-wrh-blue-600 focus:outline-none transition-colors duration-300 ease-in-out" }, " Add Additional User ", -1)
const _hoisted_34 = [
  _hoisted_33
]

import {
  ref, computed, PropType, toRefs, onMounted, watch,
} from 'vue';
import { useStore } from 'vuex';
import { isValidEmail } from '@/util/validation';
import { containsObject, validateContactData, sortBuyers } from '../services/service';
import {
  addAddtionalBuyerResponse,
  HomeBuyer, Response, StoreActions, ValidationMessages,
} from '@/constants';
import { addAdditionalUser, filterLoggedInBuyer, getUserInfo } from '@/core/user';
import { BuyerDetails, Homebuyer, ReqHomesDocument } from '@/models';
import {
  formatPhoneNumber, isMobile, checkStringEquality, showLoader,
} from '@/util/funcs';
import { UserKeys } from '@/types';
import { apiPasswordReset } from '@/api';
import Home from '@/util/home';
import UserAvatar from '@/components/UserAvatar.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  homeBuyer: {
    type: Object as PropType<Homebuyer>,
    required: true,
  },
},
  emits: ['showAlert'],
  setup(__props, { emit }) {

const props = __props
const order = [HomeBuyer.BUYER, HomeBuyer.CO_BUYER, HomeBuyer.ADDITIONAL_USER];



const { homeBuyer } = toRefs(props);
const store = useStore();

const selectedHome = computed(() => store.getters.selectedHome as ReqHomesDocument);

const buyerId = computed(() => store.getters.homebuyerId as string);
const isAdmin = computed(() => store.getters.isLoginAsAdmin);
const user = ref({
  firstName: '',
  lastName: '',
  email: '',
  mobilephone: '',
  photoURL: '',
});
const { isAdditionUser } = Home.useHome()!;
const errors = ref<Record<string, unknown>>({});
const isVisibleForm = ref(false);
const loading = ref(false);
const additionalBuyers = ref<BuyerDetails[]>([]);


const showModal = (modalType: Response) => {
  emit('showAlert', modalType);
};

const validateData = () => {
  const validationError = validateContactData(user.value.firstName, user.value.lastName, user.value.mobilephone);
  if (Object.keys(validationError).length) {
    errors.value = validationError;
  }
  if (!isValidEmail(user.value.email)) {
    errors.value.email = user.value.email.length ? ValidationMessages.InvalidEmailError : ValidationMessages.BlankEmailError;
  }
};

const clearFormFields = () => {
  Object.keys(user.value).forEach((key) => {
    user.value[key as UserKeys] = '';
  });
};

const addAdditional = (newUser: any, res: any) => {
  additionalBuyers.value.push({ ...newUser, type: HomeBuyer.ADDITIONAL_USER, buyerType: res.data.type });
  const updatedData = selectedHome.value;
  updatedData.homebuyers.push({ homeBuyerId: res.data.homeBuyerId, type: HomeBuyer.ADDITIONAL_USER });
  store.dispatch(StoreActions.SET_SELECTED_HOME, updatedData);
};

const addUser = async () => {
  showLoader(true);
  const newUser = { ...user.value };
  const res = await addAdditionalUser(selectedHome.value.id, newUser, selectedHome.value.communityId, selectedHome.value.divisionId);

  if (res && res.message === addAddtionalBuyerResponse.create) {
    addAdditional(newUser, res);
    showModal(Response.SUCCESS);
    clearFormFields();
  } else if (res && res.message === addAddtionalBuyerResponse.update) {
    addAdditional(newUser, res);
    showModal(Response.USER_ALREADY_EXIST);
    clearFormFields();
  } else if (res?.status === 409) {
    showModal(Response.ADDITIONAL_BUYER_ERROR);
  } else {
    showModal(Response.ERROR);
  }
  showLoader(false);
};

const validateRequestData = () => {
  if (user.value.email === homeBuyer.value.email) {
    errors.value.validation = 'Cannot add a user as an additional user.';
  } else if (containsObject(user.value, additionalBuyers.value)) {
    errors.value.validation = 'A user with this email id already exists.';
  } else {
    addUser();
  }
};

const maxUsersAllowed = computed(() => store.getters.maxAdditionalUsersAllowed as number);

const submit = () => {
  errors.value = {};
  validateData();
  const totalAdditionalBuyers = additionalBuyers.value.filter((buyer) => checkStringEquality(buyer.type, HomeBuyer.ADDITIONAL_USER)).length;
  if (!Object.keys(errors.value).length) {
    loading.value = true;
    if (totalAdditionalBuyers < maxUsersAllowed.value) {
      validateRequestData();
    } else {
      errors.value.validation = `Maximum limit reached. You cannot add more than ${maxUsersAllowed.value} additional users to a home.`;
    }
  }
  loading.value = false;
};

const resendInvite = async (email: string) => {
  try {
    loading.value = true;
    await apiPasswordReset(email, {
      mailType: 'invitation',
    });
    showModal(Response.INVITESENT);
  } catch {
    showModal(Response.ERROR);
  }
  loading.value = false;
};

const getAdditionalBuyers = async () => {
  showLoader(true);
  const filteredBuyers = filterLoggedInBuyer(selectedHome.value.homebuyers, buyerId.value);
  additionalBuyers.value = await getUserInfo(filteredBuyers);
  showLoader(false);
};

const renderInviteButton = (buyer: BuyerDetails) => !!buyer.buyerType && (checkStringEquality(buyer.buyerType, HomeBuyer.ADDITIONAL_USER) && !buyer.userVerified);

onMounted(() => {
  if (buyerId.value) {
    getAdditionalBuyers();
  }
});

const getUserAvatar = (buyer: Homebuyer) => ({ firstName: buyer.firstName, lastName: buyer.lastName });

const showForm = computed(() => (!isAdditionUser.value && (isVisibleForm.value || !isMobile())));


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['grid grid-cols-1 mdlg:grid-cols-[1fr,minmax(290px,390px)] mdlg:gap-6 lg:gap-4 2xl:grid-rows-[39px,1fr]',
    {'!block m-auto mdlg:w-1/2': !_unref(showForm) }
    ])
  }, [
    (_unref(showForm))
      ? (_openBlock(), _createElementBlock("h3", _hoisted_1, " Enter Additional User information below "))
      : _createCommentVNode("", true),
    (_unref(showForm))
      ? (_openBlock(), _createElementBlock("form", {
          key: 1,
          class: "space-y-6 lg:w-2/3",
          onSubmit: _withModifiers(submit, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "Enter First Name",
              id: "userFirstName",
              class: _normalizeClass(['wrh-input border-wrh-gray-dark', {'border-red-600': Object.keys(errors.value).length && errors.value.firstname}]),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (user.value.firstName = $event)),
              disabled: _unref(isAdmin)
            }, null, 10, _hoisted_5), [
              [_vModelText, user.value.firstName]
            ]),
            (Object.keys(errors.value).length && errors.value.firstname)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(errors.value.firstname), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "Enter Last Name",
              id: "userLastName",
              class: _normalizeClass(['wrh-input border-wrh-gray-dark', {'border-red-600': Object.keys(errors.value).length && errors.value.lastname}]),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (user.value.lastName = $event)),
              disabled: _unref(isAdmin)
            }, null, 10, _hoisted_9), [
              [_vModelText, user.value.lastName]
            ]),
            (Object.keys(errors.value).length && errors.value.lastname)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(errors.value.lastname), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "Enter Phone Number",
              class: _normalizeClass(['wrh-input border-wrh-gray-dark', {'border-red-600': Object.keys(errors.value).length && errors.value.mobilePhone}]),
              id: "Phone",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (user.value.mobilephone = $event)),
              disabled: _unref(isAdmin)
            }, null, 10, _hoisted_13), [
              [_vModelText, user.value.mobilephone]
            ]),
            (Object.keys(errors.value).length && errors.value.mobilePhone)
              ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(errors.value.mobilePhone), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "Enter Email Address",
              class: _normalizeClass(['wrh-input border-wrh-gray-dark', {'border-red-600': Object.keys(errors.value).length && errors.value.email}]),
              id: "email",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (user.value.email = $event)),
              disabled: _unref(isAdmin)
            }, null, 10, _hoisted_17), [
              [_vModelText, user.value.email]
            ]),
            (Object.keys(errors.value).length && errors.value.email)
              ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(errors.value.email), 1))
              : _createCommentVNode("", true)
          ]),
          (Object.keys(errors.value).length && errors.value.validation)
            ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(errors.value.validation), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_20, [
            (!_unref(isMobile)())
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: _normalizeClass([
            'add-btn btn w-full bg-wrh-blue-light text-white rounded uppercase py-2 hover:bg-wrh-blue-600 focus:outline-none transition-colors duration-300 ease-in-out',
            {'cursor-not-allowed': loading.value }
          ]),
                  disabled: loading.value || _unref(isAdmin)
                }, " Add Additional User ", 10, _hoisted_21))
              : _createCommentVNode("", true),
            (_unref(isMobile)())
              ? (_openBlock(), _createElementBlock("button", _hoisted_22, " Add "))
              : _createCommentVNode("", true)
          ])
        ], 40, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_23, [
      (additionalBuyers.value.length)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_24, "Other Users in this home"))
        : _createCommentVNode("", true),
      _createElementVNode("ul", _hoisted_25, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sortBuyers)(additionalBuyers.value, order), (buyer, idx) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "rounded shadow-card p-6 w-full relative",
            key: idx
          }, [
            _createElementVNode("ul", _hoisted_26, [
              _createElementVNode("li", null, [
                _createVNode(UserAvatar, {
                  class: "w-10 h-10",
                  user: getUserAvatar(buyer)
                }, null, 8, ["user"])
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("h3", _hoisted_27, [
                  _createTextVNode(_toDisplayString(buyer.firstName) + " " + _toDisplayString(buyer.lastName) + " ", 1),
                  _createElementVNode("span", _hoisted_28, _toDisplayString(buyer.type), 1)
                ]),
                (buyer.mobilephone)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(_unref(formatPhoneNumber)(buyer.mobilephone)), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("p", _hoisted_31, _toDisplayString(buyer.email), 1),
              (renderInviteButton(buyer) && !_unref(isAdditionUser))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: _normalizeClass([
                  'text-wrh-blue-light font-extrabold hover:underline mt-3',
                  {'cursor-not-allowed': loading.value }
                ]),
                    disabled: loading.value,
                    onClick: ($event: any) => (resendInvite(buyer.email))
                  }, " Resend Invite ", 10, _hoisted_32))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128))
      ]),
      (_unref(isMobile)() && !isVisibleForm.value && !_unref(isAdditionUser))
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "mt-4",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (isVisibleForm.value = true))
          }, _hoisted_34))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})